module.exports = __webpack_public_path__ + "img/dvojluzkovy_pokoj_2.ed03e190.jpg";